
import { useEffect } from 'react';
export function Tools() {
return (
<div className="component-tools">
    <img src="/image/tools.png" alt="" />
</div>
)
}